import { render, staticRenderFns } from "./Mershandising.vue?vue&type=template&id=2ba10c78"
import script from "./Mershandising.vue?vue&type=script&lang=js"
export * from "./Mershandising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports